<template>
  <v-btn
    :class="
      this.isDisabled ? $style.startWallButtonDisabled : $style.startWallButton
    "
    flat
    @click="pushButton()"
  >
    <v-icon
      :class="
        this.isDisabled
          ? $style.startWallButtonIconDisabled
          : $style.startWallButtonIcon
      "
      v-bind="{ color: isStartWall ? '#FFC000' : '#333333' }"
      small
      left
    >
      fas fa-star
    </v-icon>
    {{ lang.set_start_wall }}
  </v-btn>
</template>

<script>
export default {
  name: "vc-share-set-start-wall-button",
  props: {
    lang: {
      type: Object,
      default: () => {
        return {
          set_start_wall: "スタートWALL",
          dialog_message:
            "アクセス時のスタートWALLとして設定します。よろしいですか？",
          dialog_ok_btn: "OK",
          dialog_cancel_btn: "キャンセル"
        };
      }
    },
    initialStartWallId: {
      type: String,
      default: ""
    },
    // stateToProps
    startWallId: {
      type: String,
      default: ""
    },
    targetWallId: {
      type: String,
      default: ""
    },
    // actionsToProps
    openAlertDialog: {
      type: Function,
      default: () => {}
    },
    setStartWall: {
      type: Function,
      default: () => {}
    },
    // mutationsToProps
    setStartWallId: {
      type: Function,
      default: () => {}
    },
    setTargetWallId: {
      type: Function,
      default: () => {}
    }
  },
  computed: {
    isStartWall: function() {
      return (
        this.targetWallId !== "" &&
        this.targetWallId !== null &&
        this.targetWallId === this.startWallId
      );
    },
    isDisabled: function() {
      return this.targetWallId === "" || this.targetWallId === null;
    }
  },
  data: function() {
    return {};
  },
  mounted: function() {
    this.setStartWallId(this.initialStartWallId);

    window.addEventListener("message", this.onMessageCurrentTargetWallId);
  },
  methods: {
    onMessageCurrentTargetWallId(event) {
      if (event.data.event === "currentTargetWallId") {
        this.setTargetWallId(event.data.wall_id);
        // console.log("currentTargetWallId: " + event.data.wall_id);
      }
    },
    pushButton() {
      if (!this.isStartWall && !this.isDisabled) {
        this.openAlertDialog({
          title: "", // タイトル無し
          message: this.lang.dialog_message,
          ok_btn: this.lang.dialog_ok_btn,
          cancel_btn: this.lang.dialog_cancel_btn,
          closeDialogAction: this.setStartWall
        });
      } else {
        // スタートWALL設定済みの場合は何もしない (トグルしてスタートWALL設定解除はしない)
        // console.log("push button ignored. target = " + this.targetWallId + " start = " + this.startWallId);
      }
    }
  }
};
</script>
<style module>
.startWallButton {
  margin-top: 0px;
  padding-left: 6px;
  padding-right: 6px;
}
.startWallButtonDisabled {
  margin-top: 0px;
  padding-left: 6px;
  padding-right: 6px;
  color: #333333 !important;
}
.startWallButtonIcon {
  border: 2px solid;
  border-radius: 50%;
  border-color: white;
  padding: 8px;
  margin-right: 6px !important;
}
.startWallButtonIconDisabled {
  border: 2px solid;
  border-radius: 50%;
  border-color: #333333;
  padding: 8px;
  margin-right: 6px !important;
}
</style>
